<template>
  <b-overlay :show="isLoading">
    <b-row v-if="stepDiscountDetails">
      <b-col cols="12">
        <b-card>
          <h1 class="mb-3">ویرایش تخفیف پلکانی</h1>
          <b-row>
            <b-col cols="12" md="6">
              <b-form-group
                label="عنوان تخفیف (جهت نمایش به ادمین)"
                label-for="title"
              >
                <b-form-input
                  v-model="stepDiscountDetails.title"
                  id="title"
                  trim
                  placeholder="برای مثال تخفیف 40 دقیقه"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="تعداد دقیقه مورد نیاز برای اعمال تخفیف"
                label-for="minute"
              >
                <b-input-group size="lg" append="دقیقه">
                  <b-form-input
                    v-model="stepDiscountDetails.minute"
                    id="minute"
                    trim
                    type="number"
                    placeholder="40"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group label="مقدار تخفیف به درصد (%)" label-for="percent">
                <b-input-group size="lg" append="%">
                  <b-form-input
                    v-model="stepDiscountDetails.percent"
                    id="percent"
                    trim
                    type="number"
                    placeholder="3"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-form-group
                label="رنگ سلول در این پله تخفیف"
                label-for="colorCode"
              >
                <b-input-group
                  size="lg"
                  :append="stepDiscountDetails.colorCode"
                >
                  <b-form-input
                    v-model="stepDiscountDetails.colorCode"
                    id="colorCode"
                    trim
                    type="color"
                    placeholder="3"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-checkbox v-model="stepDiscountDetails.isActive">
                تخفیف فعال باشد
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="d-flex align-items-center justify-content-end"
            >
              <b-button
                @click="updateASingleScheduleStepDiscount"
                variant="success"
                :disabled="isSubmitButtonDisabled"
              >
                ثبت
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
export default {
  mounted() {
    this.getASingleScheduleStepDiscount();
  },
  data() {
    return {
      isLoading: false,
      stepDiscountDetails: null,
    };
  },
  methods: {
    async getASingleScheduleStepDiscount() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleScheduleStepDiscount = new GetASingleScheduleStepDiscount(
          _this
        );
        getASingleScheduleStepDiscount.setRequestParam({
          id: _this.$route.params.id,
        });
        await getASingleScheduleStepDiscount.fetch((res) => {
          _this.stepDiscountDetails = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async updateASingleScheduleStepDiscount() {
      try {
        this.isLoading = true;
        let _this = this;
        let updateASingleScheduleStepDiscount =
          new UpdateASingleScheduleStepDiscount(_this);
        updateASingleScheduleStepDiscount.setRequestParamDataObj(
          _this.stepDiscountDetails
        );
        await updateASingleScheduleStepDiscount.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "تخفیف با موفقیت ویرایش شد.",
              },
            });
            _this.getASingleScheduleStepDiscount();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    isSubmitButtonDisabled() {
      if (
        !this.stepDiscountDetails.title ||
        !this.stepDiscountDetails.minute ||
        !this.stepDiscountDetails.percent ||
        !this.stepDiscountDetails.colorCode
      ) {
        return true;
      }
      return false;
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BInputGroup,
  },
};
import {
  BCard,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BInputGroup,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  GetASingleScheduleStepDiscount,
  UpdateASingleScheduleStepDiscount,
} from "@/libs/Api/ScheduleStepDiscount";
</script>
